module.exports = __webpack_public_path__ + "static/media/data-info.644ea5bc.svg";